/* eslint-disable jsx-a11y/mouse-events-have-key-events */

import * as React from 'react';
import {
  IconButton,
  Typography,
  // eslint-disable-next-line no-unused-vars
  Theme,
} from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { combine } from '../utils';

const useStyles = makeStyles()((theme: Theme) => ({
  leftBorderRadius: {
    borderRadius: '50% 0 0 50%',
  },
  rightBorderRadius: {
    borderRadius: '0 50% 50% 0',
  },
  buttonContainer: {
    display: 'flex',
  },
  button: {
    height: 36,
    width: 36,
    padding: 0,
    borderRadius: '50%',
  },
  buttonText: {
    lineHeight: 1.6,
  },
  outlined: {
    border: `1px solid #888888`,
  },
  filled: {
    '&:hover': {
      backgroundColor: '#0096D3',
    },
    backgroundColor: '#0096D3',
  },
  highlighted: {
    backgroundColor: '#CCEAF6',
  },
  contrast: {
    color: theme.palette.primary.contrastText,
  },
}));

interface DayProps {
  filled?: boolean;
  outlined?: boolean;
  highlighted?: boolean;
  disabled?: boolean;
  startOfRange?: boolean;
  endOfRange?: boolean;
  onClick?: () => void;
  onHover?: () => void;
  value: number | string;
}

const Day: React.FunctionComponent<DayProps> = ({
  startOfRange,
  endOfRange,
  disabled,
  highlighted,
  outlined,
  filled,
  onClick,
  onHover,
  value,
}: DayProps) => {
  const { classes } = useStyles();

  return (
    <div
      className={combine(
        classes.buttonContainer,
        startOfRange && classes.leftBorderRadius,
        endOfRange && classes.rightBorderRadius,
        !disabled && highlighted && classes.highlighted,
      )}
    >
      <IconButton
        className={combine(
          classes.button,
          !disabled && outlined && classes.outlined,
          !disabled && filled && classes.filled,
        )}
        color="secondary"
        disabled={disabled}
        onClick={onClick}
        onMouseOver={onHover}
        size="small">
        <Typography
          color={!disabled ? 'textPrimary' : 'textSecondary'}
          className={combine(classes.buttonText, !disabled && filled && classes.contrast)}
          variant="body2"
        >
          {value}
        </Typography>
      </IconButton>
    </div>
  );
};

export default Day;
